/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: mztNva3rOCPX

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import LoadingPlaceholder from "../../LoadingPlaceholder"; // plasmic-import: _04YMe6l7UMq/component
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import sty from "./PlasmicNewsItemPlaceholder.module.css"; // plasmic-import: mztNva3rOCPX/css

createPlasmicElementProxy;

export type PlasmicNewsItemPlaceholder__VariantMembers = {};
export type PlasmicNewsItemPlaceholder__VariantsArgs = {};
type VariantPropType = keyof PlasmicNewsItemPlaceholder__VariantsArgs;
export const PlasmicNewsItemPlaceholder__VariantProps =
  new Array<VariantPropType>();

export type PlasmicNewsItemPlaceholder__ArgsType = {};
type ArgPropType = keyof PlasmicNewsItemPlaceholder__ArgsType;
export const PlasmicNewsItemPlaceholder__ArgProps = new Array<ArgPropType>();

export type PlasmicNewsItemPlaceholder__OverridesType = {
  newsExcerptsItem?: Flex__<"div">;
  top?: Flex__<"div">;
  links?: Flex__<"div">;
};

export interface DefaultNewsItemPlaceholderProps {
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicNewsItemPlaceholder__RenderFunc(props: {
  variants: PlasmicNewsItemPlaceholder__VariantsArgs;
  args: PlasmicNewsItemPlaceholder__ArgsType;
  overrides: PlasmicNewsItemPlaceholder__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"newsExcerptsItem"}
      data-plasmic-override={overrides.newsExcerptsItem}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_bvRZj1oZhhFBeMnkX2LkQu",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.newsExcerptsItem
      )}
    >
      <div
        data-plasmic-name={"top"}
        data-plasmic-override={overrides.top}
        className={classNames("all", sty.top)}
      >
        <LoadingPlaceholder
          className={classNames("__wab_instance", sty.loadingPlaceholder__up6B)}
        />

        <div className={classNames("all", sty.freeBox__jc6Y)}>
          <LoadingPlaceholder
            className={classNames(
              "__wab_instance",
              sty.loadingPlaceholder__bwHYf
            )}
          />
        </div>
        <div className={classNames("all", sty.freeBox__k2THm)}>
          <LoadingPlaceholder
            className={classNames(
              "__wab_instance",
              sty.loadingPlaceholder__dIJa
            )}
          />

          <LoadingPlaceholder
            className={classNames(
              "__wab_instance",
              sty.loadingPlaceholder__wlTCn
            )}
          />

          <LoadingPlaceholder
            className={classNames(
              "__wab_instance",
              sty.loadingPlaceholder__hDyoY
            )}
          />
        </div>
      </div>
      <div
        data-plasmic-name={"links"}
        data-plasmic-override={overrides.links}
        className={classNames("all", sty.links)}
      >
        <LoadingPlaceholder
          className={classNames("__wab_instance", sty.loadingPlaceholder__rvjg)}
        />
      </div>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  newsExcerptsItem: ["newsExcerptsItem", "top", "links"],
  top: ["top"],
  links: ["links"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  newsExcerptsItem: "div";
  top: "div";
  links: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicNewsItemPlaceholder__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicNewsItemPlaceholder__VariantsArgs;
    args?: PlasmicNewsItemPlaceholder__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicNewsItemPlaceholder__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicNewsItemPlaceholder__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicNewsItemPlaceholder__ArgProps,
          internalVariantPropNames: PlasmicNewsItemPlaceholder__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicNewsItemPlaceholder__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "newsExcerptsItem") {
    func.displayName = "PlasmicNewsItemPlaceholder";
  } else {
    func.displayName = `PlasmicNewsItemPlaceholder.${nodeName}`;
  }
  return func;
}

export const PlasmicNewsItemPlaceholder = Object.assign(
  // Top-level PlasmicNewsItemPlaceholder renders the root element
  makeNodeComponent("newsExcerptsItem"),
  {
    // Helper components rendering sub-elements
    top: makeNodeComponent("top"),
    links: makeNodeComponent("links"),

    // Metadata about props expected for PlasmicNewsItemPlaceholder
    internalVariantProps: PlasmicNewsItemPlaceholder__VariantProps,
    internalArgProps: PlasmicNewsItemPlaceholder__ArgProps
  }
);

export default PlasmicNewsItemPlaceholder;
/* prettier-ignore-end */
